import React from 'react';
import { Link } from 'react-router-dom'
import feedback from '../static/feedback.svg';
import delhigovt from '../static/delhigovt.svg';
import logo from '../static/logo.svg';

// eslint-disable-next-line react/prefer-stateless-function
function Footer(props) {
    return (
        <div>
            <div style={{display: 'none'}} id="mobileFooter">
                <img alt="Delhi Covid Care Logo" className="logo" src={logo}/>
                <img src={delhigovt} style={{height: '70px'}} alt="Delhi Govt Logo"/>
            </div>
            <footer>
                <div id="footerlinks">
                    <Link to={'/privacy-policy/'}>
                        Privacy Policy
                    </Link>
                    <Link to={'/about/'}>
                        About
                    </Link>
                </div>
            </footer>
            <div id="feedback--btn"><img src={feedback} style={{marginRight: '8px', height: '20px'}}/>Got Feedback?
            </div>
        </div>
    );
}

export default Footer;
